export default __webpack_public_path__ + "static/media/politica-de-gobierno-ti.bf653021.pdf";